export default [
  'ACURA',
  'ALFA-ROMEO',
  'AMERICAN MOTORS',
  'ASTON MARTIN',
  'AUDI',
  'BMW',
  'BENTLEY',
  'BRICKLIN',
  'BUICK',
  'CADILLAC',
  'CHECKER',
  'CHEVROLET',
  'CHRYSLER',
  'CITROEN',
  'DAEWOO',
  'DAIHATSU',
  'DE TOMASO',
  'DELOREAN',
  'DODGE',
  'EAGLE',
  'FERRARI',
  'FIAT',
  'FISKER',
  'FORD',
  'GMC',
  'HONDA',
  'HYUNDAI',
  'INFINITI',
  'INTERNATIONAL HARVESTER',
  'ISUZU',
  'JAGUAR',
  'JEEP',
  'JENSEN',
  'KIA',
  'LAMBORGHINI',
  'LEXUS',
  'LINCOLN',
  'LOTUS',
  'MAHINDRA',
  'MASERATI',
  'MAYBACH',
  'MAZDA',
  'MERCEDES-BENZ',
  'MERCURY',
  'MERKUR',
  'MINI',
  'MITSUBISHI',
  'NISSAN',
  'OLDSMOBILE',
  'OPEL',
  'PEUGEOT',
  'PLYMOUTH',
  'PONTIAC',
  'PORSCHE',
  'RENAULT',
  'ROLLS ROYCE',
  'ROVER',
  'SAAB',
  'SATURN',
  'SCION',
  'SKODA',
  'SMART',
  'STUDEBAKER',
  'SUBARU',
  'SUZUKI',
  'TVR',
  'TOYOTA',
  'TRIUMPH',
  'VOLKSWAGEN',
  'VOLVO',
];



// WEBPACK FOOTER //
// ./src/store/data/makes.ts